import router from "@/router";

export default {
  data() {
    return {
      //设置默认的分享参数
      user: null,
    };
  },

  async onLoad() {},
  computed: {
    // 获取时间(好像没有用)
    getTime() {
      return (l) => {
        let d = new Date(l);
        let timestamp = d.getTime();
        let d2 = new Date();
        let timestamp2 = d2.getTime();
        if (timestamp2 - timestamp < 30 * 24 * 60 * 60 * 1000) {
          return this.$u.timeFrom(timestamp, "mm-dd hh:MM");
        } else {
          return this.$u.date(timestamp, "mm-dd hh:MM");
        }
      };
    },
    // 获取图片
    getImg() {
      return (l) => {
        try {
          let arr = JSON.parse(l);
          if (Array.isArray(arr)) {
            return arr[0];
          }
        } catch (error) {
          return "";
        }
      };
    },
  },

  methods: {
    // 跳转页面
    nav_to(url) {
      router.push(url);
    },

    back_to() {
      router.go(-1);
    },
  },
};
